import React, { useState } from 'react'
import { Header, TableSearch, NoData } from '../shared'

// Read-only copy of the tracker import blacklist hardcoded in hlt-backend
// (src/app/trackers/v1/trackers/config.ts). Update both together.
const blacklistedDomains = [
  'heylink.com',
  'heylinktest.com',
  'heylink.io',
  'adservice.com',
  'adform.net',
  'ad.doubleclick.net',
  'doubleclick.net',
  'kampanj.bonniermag.se',
  'kampanj.bonniertidskrifter.se',
  'useuniquelinks',
  'useuniquelinks[coid]',
  'xn--favoritln-2ka34a.se',
  'affiliatewindow.com',
  'awin1.com',
  'awin.com',
  'cj.com',
  'pro-shopper.com',
  'tracking.surveycheck.com',
  'nielsen-onlinereg.com',
  'nielsennetpanel.com',
  'i-say.com',
  'opinionworld.be',
  'opignon-marketing.com',
  'proshopper.com',
  'thinkaction.com',
  'adrecord.com',
  'facebook.com/DigitalAdvisor.dk',
  'facebook.com',
  'partner-ads.com',
  'instagram.com',
]

const blacklistedAmazonDomains = [
  'a2z.com',
  'amazon.ca',
  'amazon.cn',
  'amazoncognito.com',
  'amazon.co.jp',
  'amazon.com',
  'amazon.com.au',
  'amazon.com.mx',
  'amazon-corp.com',
  'amazon.co.uk',
  'amazoncrl.com',
  'amazon.de',
  'amazon.es',
  'amazon.eu',
  'amazon.fr',
  'amazon.in',
  'amazon.it',
  'amazonlogistics.com',
  'amazonlogistics.eu',
  'amazon.nl',
  'amazonpay.com',
  'amazonpay.in',
  'amazonpayments.com',
  'amazon.sa',
  'amazontrust.com',
  'amzn.to',
  'associates-amazon.com',
  'images-amazon.com',
  'media-amazon.com',
  'ssl-images-amazon.com',
]

const rows = [
  ...blacklistedDomains.map((domain) => ({ domain, scope: 'All networks' })),
  ...blacklistedAmazonDomains.map((domain) => ({
    domain,
    scope: 'All networks except Amazon',
  })),
].sort((a, b) => a.domain.localeCompare(b.domain))

export const BlacklistedDomains = (props) => {
  const [search, setSearch] = useState('')

  const query = search.trim().toLowerCase()
  const shownRows = query
    ? rows.filter((row) => row.domain.toLowerCase().includes(query))
    : rows

  return (
    <>
      <Header label="Blacklisted domains" />
      <div className="card">
        <div className="p-y-20">
          <div className="text-dark m-b-4">
            Network programs for these advertiser domains are not imported as
            trackers, and existing trackers for them are deactivated on the next
            import. Domains must match exactly. The list is maintained in code,
            so ask the tech team to change it.
          </div>
          <TableSearch
            value={search}
            setValue={setSearch}
            placeholder="Search domain"
            className="search w-40"
            inputClassName="w-100 p-r-8"
            highlight
          />
        </div>
        <div className="table-container-overflow m-x--6">
          <table className="table table-bordered table-hoverable">
            <thead className="text-nowrap">
              <tr>
                <th className="w-60">Domain</th>
                <th className="w-40">Blocked on</th>
              </tr>
            </thead>
            <tbody>
              {shownRows.map((row) => (
                <tr key={row.domain}>
                  <td className="text-dark">{row.domain}</td>
                  <td>{row.scope}</td>
                </tr>
              ))}
              {shownRows.length === 0 && <NoData title="No matching domains" />}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
